import rollbar from 'rollbar';

const config = {
  accessToken: window.env.BOOTSTRAP2_ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  scrubFields: ['vizia_access_token', 'idToken'],
  scrubTelemetryInputs: true,
  payload: {
    environment: window.env.ENV || 'development',
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true,
        code_version: process.env.COMMIT_SHA
      }
    }
  }
};

export default function () {
  if (window.env.ENV === 'development') {
    return null;
  }
  return rollbar.init(config);
}
